// import md5 from './md5';
import md5 from 'js-md5';

const getApk = (time,urlPath) => {
  let baseUrl = "https://jqys-files.racoondigi.cn/"
  let authkey = 'e306781cb402c4d'
  // let md5Str = md5.hex(authkey+time+urlPath)
  let md5Str = md5(authkey+urlPath+time)
  let result = baseUrl+md5Str+"/"+time+urlPath
  
  return result
}

export default getApk